const shopGoodsManageV3 = {
    state:{
      //  三代机当前店铺商品
      shopGoodsManageCurrentTable:{},
      // 当前操作店铺
      shopGoodsManageV3CurrentSite:{},
      // 当前操作店铺的批次id
      shopGoodsManageV3SiteSchId:'',
    },
    action:{

    },
    mutations: {
      // 提交的tab
      SET_SHOP_GOODS_MANAGE_CURRENT_TABLE:(state, obj) => {
        state.shopGoodsManageCurrentTable = obj
      },
      // 提交的tab
      SET_SHOP_GOODS_MANAGE_CURRENT_SITE:(state, obj) => {
        console.log(obj.siteId,'--当前店铺id');
        state.shopGoodsManageV3CurrentSite = obj
      },
      SET_SHOP_GOODS_MANAGE_CURRENT_SITE_SCHID:(state, id) => {
        console.log(id,'--当前批次id');
        state.shopGoodsManageV3SiteSchId = id
      },
    }
}
export default shopGoodsManageV3
